import { SurveyComponent, useSurvey, Survey } from "@tree-company/tree-query";
import { survey } from "./surveys/";
import { Routes, Route, Navigate } from "react-router-dom";
import { Footer } from "./components/footer";
import { useEffect, createContext } from "react";
import { Languages } from "@tree-company/collect-js-client";
import { DEFAULT_LANGUAGE } from "./locales";
import { Progress } from "./components/progress";
import { withSentryReactRouterV6Routing } from "@sentry/react";

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export const LanguageContext = createContext<Languages>(DEFAULT_LANGUAGE);
export const SurveyContext = createContext<Survey>(survey);

function languageFromLocation() {
  if (window.location.toString().includes("notreenergie.be")) {
    return Languages.fr;
  } else if (window.location.toString().includes("unsereenergie.be")) {
    return Languages.de;
  } else {
    return Languages.nl;
  }
}

export default function App() {
  return (
    <SentryRoutes>
      <Route
        path="/"
        element={
          <Navigate
            to={`/${languageFromLocation()}${window.location.search}`}
          />
        }
      />
      <Route path="/nl" element={<SurveyPage lang={Languages.nl} />} />
      <Route path="/fr" element={<SurveyPage lang={Languages.fr} />} />
      <Route path="/de" element={<SurveyPage lang={Languages.de} />} />
    </SentryRoutes>
  );
}

function SurveyPage({ lang }: { lang: Languages }) {
  const { currentPageIndex } = useSurvey(survey);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [currentPageIndex]);

  useEffect(() => {
    survey.treesponse.language = lang;
    // Force a re-render
    survey.notify();
    survey.currentPage.notify();
  }, [lang]);

  return (
    <LanguageContext.Provider value={lang}>
      <Progress survey={survey} />
      <SurveyComponent survey={survey} key={lang} />
      <Footer />
    </LanguageContext.Provider>
  );
}
